<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <activity-dialog ref="activeDialogRef" />
    <agree-privacy-dialog />
  </div>
</template>

<script>
import { getJXAddress } from '@/common/login'
import { checkSystemUpgrade } from '@/services/module/config'

import ActivityDialog from '@/components/dialog/activity-dialog'
import AgreePrivacyDialog from '@/components/dialog/agree-privacy-dialog'

export default {
  components: {
    ActivityDialog,
    AgreePrivacyDialog
  },
  provide: function () {
    return {
      openActiveDialog: this.openActiveDialog
    }
  },
  mounted() {
    this.checkIsInMaintenance()
  },
  methods: {
    openActiveDialog() {
      this.$refs.activeDialogRef.open()
    },
    /**
     * 检查是否处于维护状态
     */
    async checkIsInMaintenance() {
      try {
        let { data } = await checkSystemUpgrade()
        if (data.running) {
          window.location.href = `${getJXAddress()}/pc/maintenance?platform=10009&isMini=0&maintenanceInfo=${encodeURIComponent(
            JSON.stringify(data)
          )}`
        }
      } catch (e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="scss">
@import 'style/base';

#app {
  font-size: 14px;
  color: #333;
}
</style>
